import { render, staticRenderFns } from "./PaginatedContent.vue?vue&type=template&id=5a5db4d4"
import script from "./PaginatedContent.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginatedContent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PaginatedContent.vue?vue&type=style&index=0&id=5a5db4d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports